import { useEffect, useState } from "react";
import { IRestaurantDetail } from "../models/IRestaurantDetail";
import { DeliveryAddress, IRestaurantDeliveryAddress, PutDeliveryAddress } from "../models/IRestaurantDeliveryAddress";
import { getRestaurantsDeliveryAddress, putRestaurantsDeliveryAddress } from "../services/restaurant";
import { getCityList } from "../services/locations";
import { City } from "../models/IOrders";
import AddRestaurantDeliveryTown from "./AddRestaurantsDeliveryTown";

function EditRestaurantDeliveryAddress(props: { restaurant?: IRestaurantDetail }) {
  const [refreshKey, setRefreshKey] = useState(0);
  const [loading, setloading] = useState<boolean>();
  const [myrestaurant, setRestaurant] = useState<IRestaurantDetail>();
  const [selectedDeliveryAddress, setselectedDeliveryAddress] = useState<DeliveryAddress | null>(null);
  const [putDeliveryAddress, setputDeliveryAddress] = useState<PutDeliveryAddress | null>(null);
  const [RestaurantDeliveryAddress, setRestaurantDeliveryAddress] = useState<IRestaurantDeliveryAddress | null>(null);
  const [cityMap, setCityMap] = useState<Record<string, string>>({});

  // City listesini çek → id:name map yap
  useEffect(() => {
    getCityList().then((res) => {
      if (res.data) {
        const map: Record<string, string> = {};
        (res.data as City[]).forEach(c => { map[c.id] = c.cityNameTr; });
        setCityMap(map);
      }
    }).catch(() => {});
  }, []);

  useEffect(() => { getDeliveryAddress(); }, [refreshKey]);
  useEffect(() => { getDeliveryAddress(); }, [myrestaurant]);

  useEffect(() => {
    if (props.restaurant) setRestaurant(props.restaurant);
  }, [props.restaurant]);

  useEffect(() => {
    if (selectedDeliveryAddress) {
      setloading(true);
      putRestaurantsDeliveryAddress(putDeliveryAddress!, selectedDeliveryAddress.id)
        .then(() => {})
        .finally(() => getDeliveryAddress());
    }
  }, [selectedDeliveryAddress]);

  const updateAddressStatus = (address: DeliveryAddress) => {
    address.restourantDeliveryAddressIsEnabled = !address.restourantDeliveryAddressIsEnabled;
    address.restaurantId = props.restaurant!.id!;
    setselectedDeliveryAddress(address);
    setputDeliveryAddress({
      restourantDeliveryAddressIsEnabled: address.restourantDeliveryAddressIsEnabled,
      restourantId: props.restaurant!.id!,
      townId: address.townId,
    });
  };

  const getDeliveryAddress = () => {
    const userJson = localStorage.getItem("user");
    if (userJson && props.restaurant?.id) {
      getRestaurantsDeliveryAddress(props.restaurant.id)
        .then((response) => {
          if (response.data) setRestaurantDeliveryAddress(response.data);
        })
        .finally(() => setloading(false));
    }
    if (props.restaurant) setRestaurant(props.restaurant);
  };

  // cityId bazında grupla
  const groupedByCity = (): Record<string, DeliveryAddress[]> => {
    if (!RestaurantDeliveryAddress) return {};
    return RestaurantDeliveryAddress.reduce((acc, adres) => {
      const cityId = adres.town.cityId ?? 'other';
      if (!acc[cityId]) acc[cityId] = [];
      acc[cityId].push(adres);
      return acc;
    }, {} as Record<string, DeliveryAddress[]>);
  };

  const grouped = groupedByCity();
  const totalActive = RestaurantDeliveryAddress?.filter(a => a.restourantDeliveryAddressIsEnabled).length ?? 0;
  const totalPassive = RestaurantDeliveryAddress?.filter(a => !a.restourantDeliveryAddressIsEnabled).length ?? 0;

  return (
    <div className="py-3">
      {/* Yeni bölge ekleme formu */}
      <AddRestaurantDeliveryTown
        onSave={() => setRefreshKey(prev => prev + 1)}
        restaurant={myrestaurant}
      />

      {/* Loading */}
      {loading && (
        <div className="text-center py-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Yükleniyor...</span>
          </div>
        </div>
      )}

      {!loading && RestaurantDeliveryAddress && (
        <div>
          {/* İstatistik satırı */}
          <div className="d-flex gap-3 mb-4 flex-wrap">
            <div
              className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
              style={{ background: '#f0fdf4', border: '1px solid #bbf7d0' }}
            >
              <i className="bi bi-check-circle-fill text-success"></i>
              <span className="fw-semibold" style={{ color: '#166534', fontSize: '0.88rem' }}>
                {totalActive} Aktif Bölge
              </span>
            </div>
            <div
              className="d-flex align-items-center gap-2 px-3 py-2 rounded-3"
              style={{ background: '#fafafa', border: '1px solid #e5e7eb' }}
            >
              <i className="bi bi-dash-circle text-secondary"></i>
              <span className="fw-semibold" style={{ color: '#6b7280', fontSize: '0.88rem' }}>
                {totalPassive} Pasif Bölge
              </span>
            </div>
          </div>

          {/* Boş durum */}
          {RestaurantDeliveryAddress.length === 0 ? (
            <div className="text-center text-muted py-5">
              <i className="bi bi-geo-alt" style={{ fontSize: '2.5rem', opacity: 0.35 }}></i>
              <div className="mt-2 small">Henüz teslimat bölgesi eklenmemiş.</div>
            </div>
          ) : (
            /* Kent başlıklarına göre gruplar */
            Object.entries(grouped).map(([cityId, adresList]) => {
              const cityName = cityMap[cityId] ?? 'Diğer';
              const activeCount = adresList.filter(a => a.restourantDeliveryAddressIsEnabled).length;
              return (
                <div key={cityId} className="mb-4">
                  {/* Kent başlığı */}
                  <div className="d-flex align-items-center mb-3">
                    <div style={{ width: '4px', height: '22px', background: '#3b82f6', borderRadius: '3px', marginRight: '10px', flexShrink: 0 }} />
                    <h6 className="mb-0 fw-bold text-uppercase" style={{ color: '#374151', letterSpacing: '0.04em', fontSize: '0.85rem' }}>
                      <i className="bi bi-buildings me-2 text-primary"></i>
                      {cityName}
                    </h6>
                    <span
                      className="badge ms-2"
                      style={{ background: '#eff6ff', color: '#1d4ed8', fontSize: '0.72rem', borderRadius: '20px', padding: '3px 9px' }}
                    >
                      {activeCount}/{adresList.length}
                    </span>
                  </div>

                  {/* Bölge kartları */}
                  <div className="row g-2">
                    {adresList.map((adres) => {
                      const isActive = adres.restourantDeliveryAddressIsEnabled;
                      return (
                        <div key={adres.id} className="col-6 col-md-4 col-lg-3">
                          <div
                            className="d-flex align-items-center justify-content-between p-3 rounded-3"
                            style={{
                              border: isActive ? '1.5px solid #86efac' : '1.5px solid #e5e7eb',
                              background: isActive ? '#f0fdf4' : '#fafafa',
                              transition: 'all 0.2s',
                              boxShadow: isActive
                                ? '0 2px 8px rgba(34,197,94,0.12)'
                                : '0 1px 4px rgba(0,0,0,0.04)',
                            }}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <i
                                className={`bi ${isActive ? 'bi-geo-alt-fill' : 'bi-geo-alt'}`}
                                style={{ color: isActive ? '#16a34a' : '#9ca3af', fontSize: '0.95rem' }}
                              />
                              <span
                                className="fw-semibold"
                                style={{ fontSize: '0.82rem', color: isActive ? '#166534' : '#6b7280' }}
                              >
                                {adres.town.townNameTr}
                              </span>
                            </div>
                            <div className="form-check form-switch mb-0 ms-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isActive}
                                onChange={() => updateAddressStatus(adres)}
                                style={{ width: '2.2rem', height: '1.2rem', cursor: 'pointer' }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
}

export default EditRestaurantDeliveryAddress;